import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    search: "",
    dialogOpen: false,
    selectedUser: null,
    customerId: null,
};
const usersSlice = createSlice({
    name: "users",
    initialState,
    reducers: {
        setSearch(state, action) {
            state.search = action.payload;
        },
        setDialogOpen(state, action) {
            state.dialogOpen = action.payload;
        },
        setSelectedUser(state, action) {
            state.selectedUser = action.payload;
        },
        setCustomerId(state, action) {
            state.customerId = action.payload;
        },
    },
});
export const { setCustomerId, setSearch, setSelectedUser, setDialogOpen } = usersSlice.actions;
export default usersSlice.reducer;
export const usersSelector = (state) => state.users;
